<template>
  <div>
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <textarea
          v-model="formFields.body"
          required
          @keydown.enter="submitForm"
        />
      </div>

      <button
        type="submit"
        class="btn btn-primary btn-sm"
        :disabled="formSubmitting"
      >
        Update Comment
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'EditComment',
  props: {
    comment: {
      type: Object,
      required: true,
    },
    parentId: {
      type: Number,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      formFields: {
        body: '',
      },
    };
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.formFields = {
        body: this.comment.body,
      };
    },
    async submitForm() {
      this.formErrors = {};
      this.formSubmitting = true;

      const responseData = await this.api({
        url: `comments/${this.comment.id}/`,
        method: 'PATCH',
        json: this.formFields,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$emit('success');
        this.$store.dispatch('update_post', { id: this.parentId });
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = [
          'Unable to communicate with the server. Please check your '
          + 'connection and try again.',
        ];
      }
    },
  },
};
</script>
